// src/context/ProjectContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchProjects } from "../services/projects";

const ProjectContext = createContext();

export const useProject = () => useContext(ProjectContext);

export const ProjectProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        const fetchedProjects = await fetchProjects();
        setProjects(fetchedProjects); // Store fetched projects
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProjectData();
  }, []);

  return (
    <ProjectContext.Provider
      value={{
        projects, // Expose projects
        project,
        fetchProjects,
        setProject,
        loading,
        error,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};
